/*
    Contains the logic behind a shop.
*/
export default class ItemShop {
    constructor(public Cost: number,
        public Name: string,
        public Description: string,
        public ImagePath: string,
        public Owned: boolean = false,
        public Image?: Phaser.GameObjects.Image,
        public FrameImage?: Phaser.GameObjects.Image,
        public GoldImage?: Phaser.GameObjects.Image,
        public GoldText?: Phaser.GameObjects.Text) { }
}